import dayjs, { type PluginFunc } from 'dayjs';
import utc from 'dayjs/plugin/utc';

const templateMap = {
  h: 'YYYY-MM-DD HH',
  m: 'YYYY-MM-DD HH:mm',
  s: 'YYYY-MM-DD HH:mm:ss',
};

export type TemplateMapKeys = keyof typeof templateMap;

export function formatDate(
  data?: dayjs.ConfigType,
  to: TemplateMapKeys = 's',
  utc = true,
  template?: string
) {
  const template_ = template || templateMap[to];
  return dayjs(data, { utc }).format(template_);
}

export function formatSeconds(
  seconds: number,
  to?: TemplateMapKeys,
  utc?: boolean,
  template?: string
) {
  return formatDate(seconds, to, utc, template);
}

export const globalUTC: PluginFunc = (option, Dayjs, dayjs) => {
  utc(option, Dayjs, dayjs);

  const proto: any = Dayjs.prototype;

  const oldParse = proto.parse;

  proto.parse = function (cfg: any) {
    cfg = { utc: true, ...cfg };
    oldParse.call(this, cfg);
  };
};

export const formatMessageTime = (timestamp: number, nowTime: number) => {
  const target = dayjs(timestamp);
  const now = dayjs(nowTime);

  if (target.isSame(now, 'day')) {
    return target.format('HH:mm');
  } else if (target.isSame(now.subtract(1, 'day'), 'day')) {
    return 'Yesterday';
  } else if (
    target.isBefore(now.subtract(1, 'day'), 'day') &&
    target.isSame(now, 'year')
  ) {
    return target.format('MMM D');
  } else {
    return target.format('MMM D, YYYY');
  }
};

/**
 *
 * @param duration milliseconds
 * @returns '10d:10h:10m'
 */
export function formatDuration(milliseconds: number) {
  const durationInSeconds = Math.floor(milliseconds / 1000);
  const days = Math.floor(durationInSeconds / (60 * 60 * 24));
  const hours = Math.floor((durationInSeconds / (60 * 60)) % 24);
  const minutes = Math.floor((durationInSeconds / 60) % 60);
  const seconds = Math.floor(durationInSeconds % 60);
  let formattedDuration = '';
  const hasDays = days > 0;
  const hasHours = hours > 0;
  if (hasDays) {
    formattedDuration += days.toString() + 'd:';
  }
  if (hasDays || hasHours) {
    formattedDuration += hours.toString().padStart(2, '0') + 'h:';
  }

  formattedDuration += minutes.toString().padStart(2, '0') + 'm';

  if (!hasDays && !hasHours) {
    formattedDuration += ':' + seconds.toString().padStart(2, '0') + 's';
  }
  return formattedDuration;
}
